<template>
  <div class="dashboard">
    <open-shop is-show @click.native="$router.push('/open-shop')" @goTab="handleGoTab" v-if="!$store.state.shop.open_shop_step_info.step_progress_complete"></open-shop>
    <el-row :gutter="24" class="panel-0">
      <el-col>
        <div class="content">
          <div class="title">{{$t('dashboard.店铺链接')}}</div>
          <el-row class="shop-link">
            <el-col :md="14" :sm="24">
              <el-row>
                <el-col :sm="24" :md="5" class="link-title">{{$t('dashboard.手机端链接')}}: </el-col>
                <el-col :sm="24" :md="13" class="link-content">
                  <a :href="shopMobileUrl" target="_blank">{{ shopMobileUrl }}</a>
                </el-col>
                <el-col :md="6" :sm="24">
                  <el-button plain size="mini" @click="copyClicked(shopMobileUrl)">{{$t('dashboard.复制')}}</el-button>
                </el-col>
              </el-row>
              <el-row>
                <el-col :sm="24" :md="5" class="link-title">{{$t('dashboard.电脑端链接')}}: </el-col>
                <el-col :sm="24" :md="13" class="link-content">
                  <a :href="shopPcUrl" target="_blank">{{ shopPcUrl }}</a>
                </el-col>
                <el-col :md="6" :sm="24">
                  <el-button plain size="mini" @click="copyClicked(shopPcUrl)">{{$t('dashboard.复制')}}</el-button>
                </el-col>
              </el-row>
              <el-row v-if="this.shopCustomizedUrl">
                <el-col :sm="24" :md="5" class="link-title">{{$t('dashboard.自定义链接')}}: </el-col>
                <el-col :sm="24" :md="13" class="link-content">
                  <a :href="shopCustomizedUrl" target="_blank">{{ shopCustomizedUrl }}</a>
                </el-col>
                <el-col :md="6" :sm="24">
                  <el-button plain size="mini" @click="copyClicked(shopCustomizedUrl)">{{$t('dashboard.复制')}}</el-button>
                </el-col>
              </el-row>
              <el-row>
                <el-col :sm="24" :md="5" class="link-title">{{$t('dashboard.操作手册链接')}}: </el-col>
                <el-col :sm="24" :md="13" class="link-content">
                  <a :href="ieshopGuideUrl" target="_blank">{{ ieshopGuideUrl }}</a>
                </el-col>
                <el-col :md="6" :sm="24">
                  <el-button plain size="mini" @click="copyClicked(ieshopGuideUrl)">{{$t('dashboard.复制')}}</el-button>
                </el-col>
              </el-row>
            </el-col>
            <el-col :md="10" :sm="24">
              <el-row :gutter="30">
                <el-col :sm="24" :md="8" class="qrcode-title">{{$t('dashboard.手机端二维码')}}: </el-col>
                <el-col :sm="24" :md="16">
                  <div style="margin: 0 auto;">
                    <canvas id="qrcode" style="width: 100px; height:100px" />
                  </div>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="24" class="panel-1">
      <el-col>
        <div class="content">
          <div class="title">{{$t('dashboard.快捷功能')}}</div>
          <el-row>
            <el-col :lg="3" :span="8" @click.native="goPage('ShopDetail')">
              <div></div>
              <span>{{$t('dashboard.店铺管理')}}</span>
            </el-col>
            <el-col id="driver-1" :lg="3" :span="8" @click.native="goPage('Management')">
              <div></div>
              <span>{{$t('dashboard.产品管理')}}</span>
            </el-col>
            <el-col id="driver-2" :lg="3" :span="8" @click.native="goPage('Categories')">
              <div></div>
              <span>{{$t('dashboard.产品分类')}}</span>
            </el-col>
            <el-col :lg="3" :span="8" @click.native="goPage('All')">
              <div></div>
              <span>{{$t('dashboard.订单中心')}}</span>
            </el-col>
            <el-col :lg="3" :span="8" @click.native="goPage('AllStock')">
              <div></div>
              <span>{{$t('dashboard.仓储管理')}}</span>
            </el-col>
            <el-col :lg="3" :span="8" @click.native="goPage('GoodsManagement')">
              <div></div>
              <span>{{$t('customize.goodsManagement')}}</span>
            </el-col>
            <el-col id="driver-3" :lg="3" :span="8" @click.native="goPage('Brand')">
              <div></div>
              <span>{{$t('customize.brand')}}</span>
            </el-col>
            <el-col :lg="3" :span="8" @click.native="goPage('FreeExpressFeePromotion')">
              <div></div>
              <span>{{$t('dashboard.运营中心')}}</span>
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="24" class="panel-2">
      <el-col :lg="8">
        <div class="content">
          <div class="title">{{$t('dashboard.新增会员')}}</div>
          <el-row type="flex" align="middle">
            <el-col>
              <div></div>
            </el-col>
            <el-col>
              <el-row type="flex" align="middle">
                <el-col>{{$t('dashboard.今日新增会员数')}}</el-col>
                <el-col>{{number_1}}</el-col>
              </el-row>
              <el-row type="flex" align="middle">
                <el-col>{{$t('dashboard.昨日新增会员数')}}</el-col>
                <el-col>{{number_2}}</el-col>
              </el-row>
            </el-col>
          </el-row>
        </div>
      </el-col>
      <el-col :lg="8">
        <div class="content">
          <div class="title">{{$t('dashboard.新增订单')}}</div>
          <el-row type="flex" align="middle">
            <el-col>
              <div></div>
            </el-col>
            <el-col>
              <el-row type="flex" align="middle">
                <el-col>{{$t('dashboard.今日订单数')}}</el-col>
                <el-col>{{number_3}}</el-col>
              </el-row>
              <el-row type="flex" align="middle">
                <el-col>{{$t('dashboard.昨日订单数')}}</el-col>
                <el-col>{{number_4}}</el-col>
              </el-row>
            </el-col>
          </el-row>
        </div>
      </el-col>
      <el-col :lg="8">
        <div class="content">
          <div class="title">{{$t('dashboard.收入')}}</div>
          <el-row type="flex" align="middle">
            <el-col>
              <div></div>
            </el-col>
            <el-col>
              <el-row type="flex" align="middle">
                <el-col :span="10">{{$t('dashboard.今日收入')}}</el-col>
                <el-col :span="14">{{number_5}}</el-col>
              </el-row>
              <el-row type="flex" align="middle">
                <el-col :span="10">{{$t('dashboard.昨日收入')}}</el-col>
                <el-col :span="14">{{number_6}}</el-col>
              </el-row>
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="24" class="panel-3">
      <el-col :lg="8">
        <div class="content">
          <el-row type="flex" align="middle">
            <el-col>
              <div></div>
            </el-col>
            <el-col>
              <el-row type="flex" align="middle">
                <el-col>{{number_7}}</el-col>
                <el-col>{{$t('dashboard.会员数量')}}</el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-row type="flex" align="middle" @click.native="goPage('MemberCenter')">
            <el-col>{{$t('dashboard.查看详情')}}</el-col>
            <el-col>
              <i class="el-icon-arrow-right"></i>
            </el-col>
          </el-row>
        </div>
      </el-col>
      <el-col :lg="8">
        <div class="content">
          <el-row type="flex" align="middle">
            <el-col>
              <div></div>
            </el-col>
            <el-col>
              <el-row type="flex" align="middle">
                <el-col>{{number_8}}</el-col>
                <el-col>{{$t('dashboard.商品数量')}}</el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-row type="flex" align="middle" @click.native="goPage('Management')">
            <el-col>{{$t('dashboard.查看详情')}}</el-col>
            <el-col>
              <i class="el-icon-arrow-right"></i>
            </el-col>
          </el-row>
        </div>
      </el-col>
      <el-col :lg="8">
        <div class="content">
          <el-row type="flex" align="middle">
            <el-col>
              <div></div>
            </el-col>
            <el-col>
              <el-row type="flex" align="middle">
                <el-col>{{number_9}}</el-col>
                <el-col>{{$t('dashboard.订单数量')}}</el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-row type="flex" align="middle" @click.native="goPage('All')">
            <el-col>{{$t('dashboard.查看详情')}}</el-col>
            <el-col>
              <i class="el-icon-arrow-right"></i>
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="24" class="panel-4">
      <el-col>
        <div class="content">
          <div class="title">{{$t('dashboard.销售统计')}}</div>
          <el-row type="flex" align="middle">
            <el-col :span="4">
              <div class="panel up" v-if="number_11 >= 0">
                <div>{{$t('dashboard.本月销售总额')}}</div>
                <div>{{number_10}}</div>
                <div>{{$t('dashboard.同比上月')}} <span>{{number_11}}%<i class="el-icon-top"></i></span></div>
              </div>
              <div class="panel down" v-if="number_11 < 0">
                <div>{{$t('dashboard.本月销售总额')}}</div>
                <div>{{number_10}}</div>
                <div>{{$t('dashboard.同比上月')}} <span>{{number_11}}%<i class="el-icon-bottom"></i></span></div>
              </div>
              <div class="panel up" v-if="number_13 >= 0">
                <div>{{$t('dashboard.本周销售总额')}}</div>
                <div>{{number_12}}</div>
                <div>{{$t('dashboard.同比上周')}} <span>{{number_13}}%<i class="el-icon-top"></i></span></div>
              </div>
              <div class="panel down" v-if="number_13 < 0">
                <div>{{$t('dashboard.本周销售总额')}}</div>
                <div>{{number_12}}</div>
                <div>{{$t('dashboard.同比上周')}} <span>{{number_13}}%<i class="el-icon-bottom"></i></span></div>
              </div>
            </el-col>
            <el-col :span="20">
              <ve-line :data="chartData"></ve-line>
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="24" class="panel-5">
      <el-col>
        <div class="content">
          <div class="title">
            <el-row type="flex" align="middle" justify="space-between">
              <el-col>{{$t('dashboard.商品受欢迎统计')}}</el-col>
              <el-col>
                <el-date-picker format="yyyy-MM-dd" value-format="yyyy-MM-dd" v-model="tableOne.search.period" type="daterange" :range-separator="$t('dashboard.至')" :start-placeholder="$t('dashboard.开始日期')" :end-placeholder="$t('dashboard.结束日期')" clearable size="mini" :picker-options="tableOne.search.pickerOptions"></el-date-picker>
              </el-col>
            </el-row>
          </div>
          <el-table :data="tableOne.datas" @row-click="handleTableOneRow">
            <el-table-column :label="$t('dashboard.商品名称')" prop="product_full_name"></el-table-column>
            <el-table-column :label="$t('dashboard.成交次数')" prop="count"></el-table-column>
          </el-table>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="24" class="panel-6">
      <el-col>
        <div class="content">
          <div class="title">
            <el-row type="flex" align="middle" justify="space-between">
              <el-col>{{$t('dashboard.最近订单统计')}}</el-col>
              <el-col>
                <el-radio-group v-model="tableTwo.search.number" size="mini">
                  <el-radio-button :label="10">{{$t('dashboard.最近10笔')}}</el-radio-button>
                  <el-radio-button :label="20">{{$t('dashboard.最近20笔')}}</el-radio-button>
                </el-radio-group>
              </el-col>
              <el-col>
                <el-date-picker format="yyyy-MM-dd" value-format="yyyy-MM-dd" v-model="tableTwo.search.period" type="daterange" :range-separator="$t('dashboard.至')" :start-placeholder="$t('dashboard.开始日期')" :end-placeholder="$t('dashboard.结束日期')" clearable size="mini"></el-date-picker>
              </el-col>
            </el-row>
          </div>
          <el-table :data="tableTwo.datas" @row-click="handleTableTwoRow">
            <el-table-column :label="$t('dashboard.订单编号')" prop="out_trade_no"></el-table-column>
            <el-table-column :label="$t('dashboard.订单状态')" :prop="`status_name_${$store.state.app.language}`"></el-table-column>
            <el-table-column :label="$t('dashboard.订单金额')">
              <template slot-scope="{row}">NZD ${{(row.goods_fee / 100).toFixed(2)}}</template>
            </el-table-column>
          </el-table>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import OpenShop from '@/views/open-shop'
import VeLine from 'v-charts/lib/line.common.js'
import request from '@/utils/request'
import Driver from 'driver.js'
import QrCodeWithLogo from 'qr-code-with-logo'

export default {
  data() {
    return {
      driver: null,
      driverSteps: [],
      number_1: 0,
      number_2: 0,
      number_3: 0,
      number_4: 0,
      number_5: 0,
      number_6: 0,
      number_7: 0,
      number_8: 0,
      number_9: 0,
      number_10: 0,
      number_11: 0,
      number_12: 0,
      number_13: 0,
      chartData: {
        columns: [],
        rows: []
      },
      tableOne: {
        search: {
          period: [],
          pickerOptions: {
            shortcuts: []
          }
        },
        datas: [],
        page: {
          pageSize: 10,
          total: 1,
          currentPage: 1
        }
      },
      tableTwo: {
        search: {
          number: 10,
          period: []
        },
        datas: [],
        page: {
          pageSize: 10,
          total: 1,
          currentPage: 1
        }
      },
      shopLogo: '',
      shopPcUrl: '',
      shopMobileUrl: '',
      shopCustomizedUrl: '',
      ieshopGuideUrl: ''
    }
  },
  watch: {
    '$store.state.app.language': {
      handler(newValue, oldValue) {
        this.initChart()
        this.initTableOnePickerOptions()
      },
      immediate: true
    },
    'tableOne.search.period'() {
      this.initTableOne()
    },
    'tableTwo.search.number'() {
      this.initTableTwo()
    },
    'tableTwo.search.period'() {
      this.initTableTwo()
    }
  },
  components: {
    OpenShop,
    VeLine
  },
  updated() {
  },
  created() {
    this.driver = new Driver(
      {
        doneBtnText: this.$t('dashboard.完成'),
        closeBtnText: this.$t('dashboard.关闭'),
        nextBtnText: this.$t('dashboard.下一步'),
        prevBtnText: this.$t('dashboard.上一步')
      }
    )
    this.initDriver()
  },
  mounted() {
    this.initInfo()
    this.initTableOne()
    this.initTableTwo()
    this.fetchShopBasic()
  },
  methods: {
    driverStart() {
      if (this.driverSteps.length > 0) {
        this.driver.defineSteps(this.driverSteps)
        this.driver.start()
        this.driver.refresh()
      }
    },
    initDriver() {
      request({
        url: '/mixed/count',
        method: 'get'
      }).then(res => {
        if (!res.data.goods_count) {
          this.driverSteps.push({
            element: '#driver-1',
            popover: {
              title: this.$t('dashboard.driver1Name'),
              description: this.$t('dashboard.driver1Desc')
            }
          })
        }
        if (!res.data.category_count) {
          this.driverSteps.push({
            element: '#driver-2',
            popover: {
              title: this.$t('dashboard.driver2Name'),
              description: this.$t('dashboard.driver2Desc')
            }
          })
        }
        if (!res.data.brand_count) {
          this.driverSteps.push({
            element: '#driver-3',
            popover: {
              title: this.$t('dashboard.driver3Name'),
              description: this.$t('dashboard.driver3Desc')
            }
          })
        }
      }).then(() => {
        this.driverStart()
      })
    },
    handleGoTab(name) {
      this.$router.push({
        path: '/open-shop',
        query: {
          step: name
        }
      })
    },
    initInfo() {
      request({
        url: '/stat/board/dash',
        method: 'get'
      }).then(res => {
        this.number_1 = res.data.dash_board_customer_data.today_new_customer_count
        this.number_2 = res.data.dash_board_customer_data.yesterday_new_customer_count
        this.number_3 = res.data.dash_board_order_data.today_all_order_count
        this.number_4 = res.data.dash_board_order_data.yesterday_all_order_count
        this.number_5 = '$' + parseFloat(res.data.dash_board_sell_data.today_sales_amount / 100).toFixed(2)
        this.number_6 = '$' + parseFloat(res.data.dash_board_sell_data.yesterday_sales_amount / 100).toFixed(2)
        this.number_7 = res.data.dash_board_customer_data.total_customer_count
        this.number_8 = res.data.dash_board_goods_data.total_goods_spu_count
        this.number_9 = res.data.dash_board_order_data.total_order_count
        this.number_10 = '$' + parseFloat(res.data.dash_board_sell_data.month_sales_amount / 100).toFixed(2)
        this.number_11 = res.data.dash_board_sell_data.month_sales_amount_compared
        this.number_12 = '$' + parseFloat(res.data.dash_board_sell_data.week_sales_amount / 100).toFixed(2)
        this.number_13 = res.data.dash_board_sell_data.week_sales_amount_compared
      })
    },
    initChart() {
      request({
        url: '/stat/board/dash/order/pay',
        method: 'get'
      }).then(res => {
        const columns = [
          this.$t('dashboard.日期')
        ]
        const rows = []
        const key = `pay_type_string_${this.$store.state.app.language}`
        res.data.forEach(val => {
          const data = {}
          val.forEach(v => {
            if (columns.indexOf(v[key]) === -1) {
              columns.push(v[key])
            }
            data[this.$t('dashboard.日期')] = v.day
            data[v[key]] = v.count
          })
          rows.push(data)
        })
        this.chartData = {
          columns,
          rows
        }
      })
    },
    initTableOne() {
      request({
        url: '/stat/board/dash/goods/popular',
        method: 'get',
        params: {
          start_date: this.tableOne.search.period ? this.tableOne.search.period[0] : null,
          end_date: this.tableOne.search.period ? this.tableOne.search.period[1] : null
        }
      }).then(res => {
        this.tableOne.datas = res.data
      })
    },
    initTableOnePickerOptions() {
      this.tableOne.search.pickerOptions.shortcuts = [
        {
          text: this.$t('dashboard.今日'),
          onClick(picker) {
            picker.$emit('pick', [new Date(), new Date()])
          }
        },
        {
          text: this.$t('dashboard.最近30天'),
          onClick(picker) {
            const start = new Date()
            const end = new Date()
            end.setDate(start.getDate() - 30)
            picker.$emit('pick', [start, end])
          }
        }
      ]
    },
    initTableTwo() {
      request({
        url: '/stat/board/dash/order',
        method: 'get',
        params: {
          show_count: this.tableTwo.search.number,
          start_date: this.tableTwo.search.period ? this.tableTwo.search.period[0] : null,
          end_date: this.tableTwo.search.period ? this.tableTwo.search.period[1] : null
        }
      }).then(res => {
        this.tableTwo.datas = res.data
      })
    },
    goPage(name) {
      if (this.$store.state.shop.open_shop_step_info.step_progress_complete) {
        this.$router.push({
          name
        })
      } else {
        this.$message.warning(this.$t('dashboard.请完成开户'))
      }
    },
    handleTableOneRow(row) {
      this.$router.push({
        name: 'EditMerchandise',
        params: {
          goodsId: row.goods_spu_id
        }
      })
    },
    handleTableTwoRow(row) {
      this.$router.push({
        name: 'OrderView',
        params: {
          orderId: row.id
        }
      })
    },
    fetchShopBasic() {
      request({
        url: '/basic',
        method: 'get'
      })
        .then(response => {
          this.shopLogo = response.data['shop_logo_url']
          if (process.env.VUE_APP_PC_URL == 'nzmai.com.cn') {
            if (window.location.href.substr(0, 5) == 'https') {
              this.shopPcUrl =
                'https://' +
                this.$store.state.shop.shop_domain_prefix +
                window.location.href.substr(14, 13)
            } else if (window.location.href.substr(0, 5) == 'http:') {
              this.shopPcUrl =
                'https://' +
                this.$store.state.shop.shop_domain_prefix +
                window.location.href.substr(13, 13)
            }
          } else if (process.env.VUE_APP_PC_URL == 'localhost:9529') {
            this.shopPcUrl = 'http://' +
              this.$store.state.shop.shop_domain_prefix +
              '.miepay.xyz'
          } else {
            this.shopPcUrl =
              'http://' +
              this.$store.state.shop.shop_domain_prefix +
              '.miepay.xyz'
          }

          if (process.env.VUE_APP_PC_URL == 'nzmai.com.cn') {
            if (window.location.href.substr(0, 5) == 'https') {
              this.shopMobileUrl =
                'https://m' +
                window.location.href.substr(14, 13) +
                '/m/' +
                this.$store.state.shop.shop_domain_prefix +
                '/home'
            } else if (window.location.href.substr(0, 5) == 'http:') {
              this.shopMobileUrl =
                'https://m' +
                window.location.href.substr(13, 13) +
                '/m/' +
                this.$store.state.shop.shop_domain_prefix +
                '/home'
            }
          } else if (process.env.VUE_APP_PC_URL == 'localhost:9529') {
            this.shopMobileUrl = 'http://localhost:8080/m/' +
              this.$store.state.shop.shop_domain_prefix +
              '/home'
          } else {
            this.shopMobileUrl =
              process.env.VUE_APP_MOBILE_URL +
              this.$store.state.shop.shop_domain_prefix +
              '/home'
          }

          if (response.data.shop_custom_host) {
            if (response.data['shop_custom_host'].substr(0, 4) !== 'http') {
              this.shopCustomizedUrl = 'https://' + response.data['shop_custom_host']
            } else {
              this.shopCustomizedUrl = response.data['shop_custom_host']
            }
          }

          this.ieshopGuideUrl = 'https://guide.nzmai.com.cn'
          this.createQrcode()
        })
    },
    createQrcode() {
      QrCodeWithLogo.toCanvas({
        canvas: document.getElementById('qrcode'),
        content: this.shopMobileUrl,
        width: 100,
        logo: {
          src: this.shopLogo + '?imageView2/0/w/200/h/200/q/90|imageslim',
          borderRadius: 5
        }
      })
    },
    copyClicked(data) {
      const url = data
      navigator.clipboard.writeText(url).then(() => {
        this.$message({
          message: this.$t('dashboard.复制成功'),
          type: 'success'
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .dashboard {
    background-color: #eee;
    padding: 24px;
    /deep/ .open-shop {
      .step {
        margin: 40px 0;
      }
    }
    & > .el-row {
      & > .el-col {
        .content {
          background-color: #fff;
          border-radius: 4px;
          .title {
            font-size: 16px;
            font-weight: bold;
            padding: 16px 24px;
          }
        }
      }
      &.panel-0 {
        margin-bottom: 12px;
        .content {
          .shop-link {
            padding: 5px 20px 10px;
          }
          .el-row {
            .el-col {
              .link-title {
                text-align: right;
              }
              .link-content {
                padding-left: 10px;
                color: #666666;
              }
              .qrcode-title {
                margin-top: 36px;
                text-align: center;
              }
              & > div {
                background-size: 100%;
                margin: 5px 0;
                line-height: 28px;
              }
              & > p {
                font-size: 14px;
              }
            }
          }
        }
      }
      &.panel-1 {
        .content {
          .el-row {
            padding: 8px 0 0 0;
            .el-col {
              display: flex;
              flex-direction: column;
              align-items: center;
              margin-bottom: 24px;
              cursor: pointer;
              & > div {
                background-size: 100%;
                width: 80px;
                height: 80px;
                margin-bottom: 12px;
              }
              & > p {
                font-size: 14px;
              }
              &:nth-of-type(1) {
                & > div {
                  background-image: url('/static/img/dashboard/pic-1.png');
                }
              }
              &:nth-of-type(2) {
                & > div {
                  background-image: url('/static/img/dashboard/pic-2.png');
                }
              }
              &:nth-of-type(3) {
                & > div {
                  background-image: url('/static/img/dashboard/pic-3.png');
                }
              }
              &:nth-of-type(4) {
                & > div {
                  background-image: url('/static/img/dashboard/pic-4.png');
                }
              }
              &:nth-of-type(5) {
                & > div {
                  background-image: url('/static/img/dashboard/pic-5.png');
                }
              }
              &:nth-of-type(6) {
                & > div {
                  background-image: url('/static/img/dashboard/pic-6.png');
                }
              }
              &:nth-of-type(7) {
                & > div {
                  background-image: url('/static/img/dashboard/pic-7.png');
                }
              }
              &:nth-of-type(8) {
                & > div {
                  background-image: url('/static/img/dashboard/pic-8.png');
                }
              }
            }
          }
        }
      }
      &.panel-2 {
        margin-top: 12px;
        & > .el-col {
          margin: 12px 0;
          .content {
            & > .el-row {
              padding: 0 0 16px 0;
              & > .el-col {
                width: auto;
                &:nth-of-type(1) {
                  margin-left: 24px;
                  div {
                    width: 84px;
                    height: 84px;
                    background-size: 100%;
                  }
                }
                &:nth-of-type(2) {
                  flex: 1;
                  margin: 0 24px;
                  .el-row {
                    &:nth-of-type(1) {
                      border-bottom: 1px solid #E8E8E8;
                    }
                    .el-col {
                      padding: 8px 0;
                      &:nth-of-type(1) {
                        font-size: 14px;
                        opacity: .65;
                      }
                      &:nth-of-type(2) {
                        font-size: 30px;
                        font-weight: bold;
                        text-align: right;
                      }
                    }
                  }
                }
              }
            }
          }
          &:nth-of-type(1) {
            .content {
              & > .el-row {
                & > .el-col {
                  &:nth-of-type(1) {
                    div {
                      background-image: url('/static/img/dashboard/pic-9.png');
                    }
                  }
                }
              }
            }
          }
          &:nth-of-type(2) {
            .content {
              & > .el-row {
                & > .el-col {
                  &:nth-of-type(1) {
                    div {
                      background-image: url('/static/img/dashboard/pic-10.png');
                    }
                  }
                }
              }
            }
          }
          &:nth-of-type(3) {
            .content {
              & > .el-row {
                & > .el-col {
                  &:nth-of-type(1) {
                    div {
                      background-image: url('/static/img/dashboard/pic-11.png');
                    }
                  }
                }
              }
            }
          }
        }
      }
      &.panel-3 {
        & > .el-col {
          margin: 12px 0;
          &.up {
            .content {
              & > .el-row {
                &:nth-of-type(1) {
                  & > .el-col {
                    &:nth-of-type(2) {
                      & > .el-row {
                        & > .el-col {
                          &:nth-of-type(3) {
                            color: #F5222D;
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          &.down {
            .content {
              & > .el-row {
                &:nth-of-type(1) {
                  & > .el-col {
                    &:nth-of-type(2) {
                      & > .el-row {
                        & > .el-col {
                          &:nth-of-type(3) {
                            color: #4DCB73;
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          .content {
            padding: 0 24px;
            & > .el-row {
              &:nth-of-type(1) {
                padding: 20px 0;
                border-bottom: 1px solid #E8E8E8;
                & > .el-col {
                  width: auto;
                  &:nth-of-type(1) {
                    div {
                      width: 64px;
                      height: 64px;
                      background-size: 100%;
                    }
                  }
                  &:nth-of-type(2) {
                    flex: 1;
                    & > .el-row {
                      & > .el-col {
                        width: auto;
                        font-size: 14px;
                        &:nth-of-type(1) {
                          flex: 1;
                          font-size: 30px;
                          font-weight: bold;
                          margin-left: 24px;
                        }
                        &:nth-of-type(2) {
                          margin: 0 16px;
                          opacity: .65;
                        }
                      }
                    }
                  }
                }
              }
              &:nth-of-type(2) {
                cursor: pointer;
                padding: 10px 0;
                & > .el-col {
                  width: auto;
                  font-size: 14px;
                  &:nth-of-type(1) {
                    flex: 1;
                  }
                }
              }
            }
          }
          &:nth-of-type(1) {
            .content {
              & > .el-row {
                &:nth-of-type(1) {
                  & > .el-col {
                    &:nth-of-type(1) {
                      div {
                        background-image: url('/static/img/dashboard/pic-12.png');
                      }
                    }
                  }
                }
              }
            }
          }
          &:nth-of-type(2) {
            .content {
              & > .el-row {
                &:nth-of-type(1) {
                  & > .el-col {
                    &:nth-of-type(1) {
                      div {
                        background-image: url('/static/img/dashboard/pic-13.png');
                      }
                    }
                  }
                }
              }
            }
          }
          &:nth-of-type(3) {
            .content {
              & > .el-row {
                &:nth-of-type(1) {
                  & > .el-col {
                    &:nth-of-type(1) {
                      div {
                        background-image: url('/static/img/dashboard/pic-14.png');
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      &.panel-4 {
        margin-top: 12px;
        & > .el-col {
          & > .content {
            & > .el-row {
              & > .el-col {
                padding: 0 24px;
                &:nth-of-type(1) {
                  border-right: 1px solid #E8E8E8;
                  .panel {
                    font-size: 14px;
                    &.up {
                      & > div {
                        &:nth-of-type(3) {
                          span {
                            color: #F5222D;
                          }
                        }
                      }
                    }
                    &.down {
                      & > div {
                        &:nth-of-type(3) {
                          span {
                            color: #4DCB73;
                          }
                        }
                      }
                    }
                    &:not(:last-of-type) {
                      margin-bottom: 24px;
                    }
                    & > div {
                      text-align: center;
                      &:nth-of-type(1) {
                        opacity: .45;
                      }
                      &:nth-of-type(2) {
                        font-size: 34px;
                        font-weight: bold;
                        margin: 12px 0;
                      }
                      &:nth-of-type(3) {
                        color: rgba(0, 0, 0, .65);
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      &.panel-5,
      &.panel-6 {
        margin-top: 24px;
        & > .el-col {
          & > .content {
            .title {
              & > .el-row {
                & > .el-col {
                  width: auto;
                }
              }
            }
            .el-table {
              padding: 0 24px;
            }
            .el-pagination {
              padding: 12px 24px;
            }
          }
        }
      }
    }
  }
</style>
